/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Html
 */
export interface Html {}

/**
 * Check if a given object implements the Html interface.
 */
export function instanceOfHtml(value: object): boolean {
    return true;
}

export function HtmlFromJSON(json: any): Html {
    return HtmlFromJSONTyped(json, false);
}

export function HtmlFromJSONTyped(json: any, ignoreDiscriminator: boolean): Html {
    return json;
}

export function HtmlToJSON(value?: Html | null): any {
    return value;
}
